import {kasseClient} from '@/js/helpers/backend-clients';
import {displayAxiosError, hideLoadingOverlay} from '@/js/helpers/utils';
import konstanten from '@/js/konstanten';
import router from '@/router';
import {setFile} from '@/plugins/axios';

export default {
  // allgemeine Angaben
  setObjektart({commit}, objektart) {
    commit('SET_OBJEKTART', objektart);
  },
  setErmittlungsstichtag({commit}, ermittlungsstichtag) {
    commit('SET_ERMITTLUNGSSTICHTAG', ermittlungsstichtag);
  },
  setBaujahr({commit}, baujahr) {
    const number = parseInt(baujahr);
    commit('SET_BAUJAHR', isNaN(number) ? undefined : number);
  },
  setWohnungsnummer({commit}, wohnungsnummer) {
    commit('SET_WOHNUNGSNUMMER', wohnungsnummer);
  },
  setAnzahlWohneinheiten({commit}, anzahlWohneinheiten) {
    const number = parseInt(anzahlWohneinheiten);
    commit('SET_ANZAHL_WOHNEINHEITEN', isNaN(number) ? undefined : number);
  },
  setAnzahlNutzeinheiten({commit}, anzahlNutzeinheiten) {
    const number = parseInt(anzahlNutzeinheiten);
    commit('SET_ANZAHL_NUTZEINHEITEN', isNaN(number) ? undefined : number);
  },
  setWohnflaeche({commit}, wohnflaeche) {
    const number = parseFloat(wohnflaeche);
    commit('SET_WOHNFLAECHE', isNaN(number) ? undefined : number);
  },
  setNutzflaeche({commit}, nutzflaeche) {
    const number = parseFloat(nutzflaeche);
    commit('SET_NUTZFLAECHE', isNaN(number) ? undefined : number);
  },
  // Auftragsdaten
  setKaufpreis({commit}, kaufpreis) {
    const number = parseFloat(kaufpreis);
    commit('SET_KAUFPREIS', isNaN(number) ? undefined : number);
  },
  setGrundstuecksflaeche({commit}, grundstuecksflaeche) {
    const number = parseInt(grundstuecksflaeche);
    commit('SET_GRUNDSTUECKSFLAECHE', isNaN(number) ? undefined : number);
  },
  setGrunderwerbssteuern({commit}, grunderwerbssteuern) {
    const number = parseFloat(grunderwerbssteuern);
    commit('SET_GRUNDERWERBSSTEUERN', isNaN(number) ? undefined : number);
  },
  setNotarkostenKaufvertrag({commit}, notarkostenKaufvertrag) {
    const number = parseFloat(notarkostenKaufvertrag);
    commit('SET_NOTARKOSTEN', isNaN(number) ? undefined : number);
  },
  setKostenGrundbucheintragung({commit}, kostenGrundbucheintragung) {
    const number = parseFloat(kostenGrundbucheintragung);
    commit('SET_GRUNDBUCHKOSTEN', isNaN(number) ? undefined : number);
  },
  setBodenrichtwertKaufzeitpunkt({commit}, bodenrichtwertKaufzeitpunkt) {
    const number = parseFloat(bodenrichtwertKaufzeitpunkt);
    commit('SET_BODENRICHTWERT', isNaN(number) ? undefined : number);
  },
  setVermietetKaufzeitpunkt({commit}, vermietetKaufzeitpunkt) {
    commit('SET_VERMIETET', vermietetKaufzeitpunkt ? vermietetKaufzeitpunkt : false);
  },
  setKaltmieteKaufzeitpunkt({commit}, kaltmieteKaufzeitpunkt) {
    const number = parseFloat(kaltmieteKaufzeitpunkt);
    commit('SET_KALTMIETE', isNaN(number) ? undefined : number);
  },
  // Lasten
  setBaulasten({commit}, baulasten) {
    commit('SET_BAULASTEN', baulasten ? baulasten : false);
  },
  setErlaeuterungBaulasten({commit}, erlaeuterungBaulasten) {
    commit('SET_BAULASTEN_ERLAEUTERUNG', erlaeuterungBaulasten);
  },
  setAltlasten({commit}, altlasten) {
    commit('SET_ALTLASTEN', altlasten ? altlasten : false);
  },
  setErlaeuterungAltlasten({commit}, erlaeuterungAltlasten) {
    commit('SET_ALTLASTEN_ERLAEUTERUNG', erlaeuterungAltlasten);
  },
  //Modernisierungen
  setKernsanierung({commit}, kernsanierung) {
    commit('SET_KERNSANIERUNG', kernsanierung ? kernsanierung : false);
  },
  setJahrDerKernsanierung({commit}, jahrDerKernsanierung) {
    const number = parseInt(jahrDerKernsanierung);
    commit('SET_JAHR_DER_KERNSANIERUNG', isNaN(number) ? undefined : number);
  },
  setBodenbelaegeModernisierung({commit}, modernisierung) {
    commit('SET_BODENBELAEGE_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setBodenbelaegeModernisierungJahr({commit}, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_BODENBELAEGE_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setBaederModernisierung({commit}, modernisierung) {
    commit('SET_BAEDER_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setBaederModernisierungJahr({commit}, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_BAEDER_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setHeizungModernisierung({commit}, modernisierung) {
    commit('SET_HEIZUNG_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setHeizungModernisierungJahr({commit}, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_HEIZUNG_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setLeitungenModernisierung({commit}, modernisierung) {
    commit('SET_LEITUNGEN_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setLeitungenModernisierungJahr({commit}, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_LEITUNGEN_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setFensterModernisierung({commit}, modernisierung) {
    commit('SET_FENSTER_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setFensterModernisierungJahr({commit}, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_FENSTER_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setDaemmungModernisierung({commit}, modernisierung) {
    commit('SET_DAEMMUNG_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setDaemmungModernisierungJahr({commit}, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_DAEMMUNG_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setDachModernisierung({commit}, modernisierung) {
    commit('SET_DACH_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setDachModernisierungJahr({commit}, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_DACH_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  setRaumaufteilungModernisierung({commit}, modernisierung) {
    commit('SET_RAUMAUFTEILUNG_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setRaumaufteilungModernisierungJahr({commit}, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_RAUMAUFTEILUNG_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },
  //Auftragsunterlagen
  setGrundbuchauszug({commit}, grundbuchauszug) {
    commit('SET_AUFTRAGSUNTERLAGEN_GRUNDBUCHAUSZUG', grundbuchauszug);
  },
  setKaufvertrag({commit}, kaufvertrag) {
    commit('SET_AUFTRAGSUNTERLAGEN_KAUFVERTRAG', kaufvertrag);
  },
  setGrundriss({commit}, grundriss) {
    commit('SET_AUFTRAGSUNTERLAGEN_GRUNDRISS', grundriss);
  },
  setMietvertraege({commit}, mietvertraege) {
    commit('SET_AUFTRAGSUNTERLAGEN_MIETVERTRAEGE', mietvertraege);
  },
  setEnergieausweis({commit}, energieausweis) {
    commit('SET_AUFTRAGSUNTERLAGEN_ENERGIEAUSWEIS', energieausweis);
  },
  setBauunterlagen({commit}, bauunterlagen) {
    commit('SET_AUFTRAGSUNTERLAGEN_BAUUNTERLAGEN', bauunterlagen);
  },
  setTeilungserklaerung({commit}, teilungserklaerung) {
    commit('SET_AUFTRAGSUNTERLAGEN_TEILUNGSERKLAERUNG', teilungserklaerung);
  },
  setZusatzdokument({commit}, zusatzdokument) {
    commit('PUSH_AUFTRAGSUNTERLAGEN_ZUSATZDOKUMENT', zusatzdokument);
  },
  removeZusatzdokument({commit}, zusatzdokument) {
    commit('REMOVE_AUFTRAGSUNTERLAGEN_ZUSATZDOKUMENT', zusatzdokument);
  },

  //Kontaktdaten
  setAnsprechpartnerName1({commit}, vorname) {
    commit('SET_ANSPRECHPARTNER_NAME_1', vorname);
  },
  setAnsprechpartnerName2({commit}, nachname) {
    commit('SET_ANSPRECHPARTNER_NAME_2', nachname);
  },
  setAnsprechpartnerTelefon({commit}, telefon) {
    commit('SET_ANSPRECHPARTNER_TELEFON', telefon);
  },
  setAnsprechpartnerErlaeuterung({commit}, erlaeuterung) {
    commit('SET_ANSPRECHPARTNER_ERLAEUTERUNG', erlaeuterung);
  },
  setAlternateAnsprechpartnerName({ commit }, alternateName) {
    commit('SET_ALTERNATE_ANSPRECHPARTNER_NAME', alternateName);
  },
  setAlternateAnsprechpartnerFunction({ commit }, alternateFunction) {
    commit('SET_ALTERNATE_ANSPRECHPARTNER_FUNCTION', alternateFunction);
  },
  setAlternateAnsprechpartnerTelefon({ commit }, alternateTelefon) {
    commit('SET_ALTERNATE_ANSPRECHPARTNER_TELEFON', alternateTelefon);
  },
  setAlternateAnsprechpartnerEmail({ commit }, alternateEmail) {
    commit('SET_ALTERNATE_ANSPRECHPARTNER_EMAIL', alternateEmail);
  },

  //Rechnungsadresse
  setDefaultRechnungName1({ commit }, name1) {
    commit('SET_DEFAULT_RECHNUNG_NAME1', name1);
  },
  setDefaultRechnungName2({ commit }, name2) {
    commit('SET_DEFAULT_RECHNUNG_NAME2', name2);
  },
  setDefaultRechnungPlz({ commit }, plz) {
    commit('SET_DEFAULT_RECHNUNG_PLZ', plz);
  },
  setDefaultRechnungOrt({ commit }, ort) {
    commit('SET_DEFAULT_RECHNUNG_ORT', ort);
  },
  setDefaultRechnungStr({ commit }, str) {
    commit('SET_DEFAULT_RECHNUNG_STR', str);
  },
  setDefaultRechnungHnr({ commit }, hnr) {
    commit('SET_DEFAULT_RECHNUNG_HNR', hnr);
  },

  setUseDefaultRechnungData({ commit }, useDefaultRechnungData) {
    commit('SET_USE_DEFAULT_RECHNUNG_DATA', useDefaultRechnungData);
  },
  setAlternativeRechnungName1({ commit }, name1) {
    commit('SET_ALTERNATIVE_RECHNUNG_NAME1', name1);
  },
  setAlternativeRechnungName2({ commit }, name2) {
    commit('SET_ALTERNATIVE_RECHNUNG_NAME2', name2);
  },
  setAlternativeRechnungPlz({ commit }, plz) {
    commit('SET_ALTERNATIVE_RECHNUNG_PLZ', plz);
  },
  setAlternativeRechnungOrt({ commit }, ort) {
    commit('SET_ALTERNATIVE_RECHNUNG_ORT', ort);
  },
  setAlternativeRechnungStr({ commit }, str) {
    commit('SET_ALTERNATIVE_RECHNUNG_STR', str);
  },
  setAlternativeRechnungHnr({ commit }, hnr) {
    commit('SET_ALTERNATIVE_RECHNUNG_HNR', hnr);
  },

  reset({commit}) {
    commit('RESET_STATE');
  },
  loadKaufpreisauteilung({state, commit, dispatch}, saved) {
    commit('RESET_STATE');
    const {
      data: {
        produkt,
        adresse,
        allgemeineAngaben: {
          auftraggeberName1,
          auftraggeberName2,
          objektart,
          baujahr,
          wohnungsnummer,
          anzahlWohneinheiten,
          anzahlNutzeinheiten,
          wohnflaeche,
          nutzflaeche,
          ermittlungsstichtag
        },
        auftragsdaten,
        lasten,
        modernisierungen,
        auftragsunterlagen,
        kontaktdaten,
        alternativeRechnung
      },
    } = saved;

    Object.assign(state.allgemeineAngaben, {
      auftraggeberName1,
      auftraggeberName2,
      objektart,
      baujahr,
      wohnungsnummer,
      anzahlWohneinheiten,
      anzahlNutzeinheiten,
      wohnflaeche,
      nutzflaeche,
      ermittlungsstichtag
    });
    Object.assign(state.auftragsdaten, auftragsdaten);
    Object.assign(state.lasten, lasten);
    Object.assign(state.modernisierungen, modernisierungen);
    Object.assign(state.ansprechpartner, kontaktdaten);
    Object.assign(state.defaultRechnung, produkt.defaultRechnung);
    Object.assign(state.alternativeRechnung, alternativeRechnung);
    state.ausSpeicherGeladen = true;

    dispatch('setAnsprechpartnerName1', auftraggeberName1);
    dispatch('setAnsprechpartnerName2', auftraggeberName2)
    commit('kasse/UPDATE_WARENKORB_PRODUKTE', [produkt], {root: true});
    commit('address/UPDATE_CURRENT_ADDRESS', adresse, {root: true});
    let promises = [];
    for (let i = 0; i < auftragsunterlagen.zusatzdokument; i++) {
      promises.push(
        kasseClient
          .downloadIndexFile('kpa', '_unterlagen_zusatz', i)
          .then(response => {
            setFile(response, 'kpa', '_unterlagen_zusatz', i, d => {
              state.auftragsunterlagen.zusatzdokument.push(d);
            });
          }),
      );
    }
    promises.push(
      ...auftragsunterlagen.unterlagen.filter(f => '_unterlagen_zusatz' !== f).map(f => {
        return kasseClient.downloadFile('kpa', f).then(response => {
          setFile(response, 'kpa', f, undefined, d => {
            state.auftragsunterlagen[konstanten.KPA_DOKUMENT_MAP[f]] = d;
          });
        });
      }),
    );
    Promise.all(promises).then(_ => {
      router.push('/konfiguration/kpa');
    })
      .catch(error => displayAxiosError(error))
      .finally(() => hideLoadingOverlay());
  },
};
